import React from 'react'

const ButtonClick = (props) => {
    const dataCount = props.data;
    console.log(dataCount);
    let buttonClickHtml = '';
    if (Object.keys(dataCount).length === 0) {
        return (
            <ul class="popularUrlList">
                <li>
                    <span>Records not found.</span>
                </li>
            </ul>
            
        )
    } else {
        let sortByTopClick = null;
        if (Object.keys(dataCount).length > 1) {
            sortByTopClick = Object.fromEntries(
                Object.entries(dataCount).sort(([, a], [, b]) => b - a)
            );
        } else {
            sortByTopClick = dataCount;
        }
        for(const btVl in sortByTopClick){
            buttonClickHtml += `<li><p>${btVl}</p><div><b>${sortByTopClick[btVl]}</b></div></li>`;
        }
    }
    return (
        <ul className="zy-clickCounts">
            <div dangerouslySetInnerHTML={{__html: buttonClickHtml }} />
        </ul>
    )
}

export default ButtonClick